import './App.css'

import Edit from './sections/edit'
import Create from './sections/create'
import Share from './sections/share'
import { AdminLogin, AdminDashboard, AdminRoute } from './sections/admin'
import { BrowserRouter, Switch, Route } from 'react-router-dom'

function App() {
  return (
    <BrowserRouter>
      <div className="App" style={{ display: 'flex', width: '100%' }}>
        <Switch>
          <Route exact path="/" component={Create} />
          <Route exact path="/edit" component={Edit} />
          <Route exact path="/share" component={Share} />
          <Route exact path="/admin/login" component={AdminLogin} />
          <AdminRoute exact path="/admin" component={AdminDashboard} />
          <Route path="*" component={Create} />
        </Switch>
      </div>
    </BrowserRouter>
  )
}

export default App
